import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useNavigate } from 'react-router-dom';
import {
  CTA,
  CustomInput,
  CustomSelect,
  Inline,
  Modal,
  NoResult,
  Text,
} from '../../..';
import { withMediaQueries } from '../../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../../style';
import { MODAL_CLOSE } from '../../../../../app/redux/actions';
import Pagination from '../../../Pagination';
import SortBy from '../../../SortBy';
import { FiltersWrapper, Legend, SortingWrapper, TutorCard } from './style';
import routes from '../../../../../routes';
import {
  getFilterLabel,
  getFilterOptions,
  getSortingOptions,
} from '../../../../../utils/labels';
import theme from '../../../../theme';
import CustomTooltip from '../../../CustomTooltip';
import { TUTOR_LIST_GET } from '../../../../../app/redux/actions/supervisorStats';
import { timestampToDate, toPercentage } from '../../../../../utils/common';

export const ModalSupervisorTutorsId = 'ModalSupervisorTutors';

const ModalSupervisorTutors = ({
  mediaIsPhone,
  total_tutor,
  tutors_by_region,
  list,
  filters,
  pager,
  getTutorList,
  modalClose,
}) => {
  const scrollableAreaRef = useRef(null);
  const navigate = useNavigate();
  // filters
  const [selectedFilters, setSelectedFilters] = useState({});
  const [totalTutors, setTotalTutors] = useState(0);

  useEffect(() => {
    getTutorList({ only_filters: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTotalTutors(Math.max(total_tutor, totalTutors));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total_tutor]);

  const handleGetTutorList = (page) => {
    if (selectedFilters.ffoo) {
      const parsedFilters = {
        ...selectedFilters,
        page,
      };
      getTutorList(parsedFilters);
    }
  };

  const handleOnChange = ({ key, value, callback = true }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
    if (callback) getTutorList({ ...newFilters, only_filters: 1 });
  };

  const handleOnChangeParent = ({ key, value, childKey }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    newFilters[childKey] = undefined;
    setSelectedFilters(newFilters);
    getTutorList({ ...newFilters, only_filters: 1 });
  };

  const loadMore = (page) => handleGetTutorList(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  return (
    <Modal
      title="Lista tutor accreditati"
      description="Sezione dedicata a tutti gli utenti che hanno il ruolo di tutor all’interno della piattaforma."
      modalId={ModalSupervisorTutorsId}
      scrollableAreaRef={scrollableAreaRef}
      mbTitle={16}
      mbDescription={32}
    >
      <FiltersWrapper>
        <CustomInput
          size={426}
          placeholder="Cosa vuoi cercare?..."
          isSearch
          value=""
          icon="search-sm"
          isClearable
          onChange={(value) =>
            handleOnChange({
              key: 'search_text',
              value: { value },
              callback: false,
            })
          }
          onClickIcon={() => handleGetTutorList()}
          onKeyPress={(event) => {
            if (event.key === 'Enter') handleGetTutorList();
          }}
        />
        {(Object.keys(filters) || []).map((key, i) => (
          <CustomSelect
            size="s"
            key={`filter-${i}`}
            wrapperId={`filter-${key}`}
            placeholder={getFilterLabel(key)}
            options={getFilterOptions(filters, key)}
            onChange={(value) => {
              if (key === 'regions') {
                handleOnChangeParent({ key, value, childKey: 'provinces' });
              } else if (key === 'ffoo') {
                handleOnChangeParent({
                  key,
                  value,
                  childKey: 'user_work_role',
                });
              } else handleOnChange({ key, value });
            }}
            isClearable
            isSearchable={key === 'regions' || key === 'provinces'}
            selected={
              getFilterOptions(filters, key)?.find(
                (o) => o.value === selectedFilters[key]
              ) || null
            }
            className={key === 'ffoo' ? 'mandatory-select' : ''}
            disabled={key === 'user_work_role' && !selectedFilters.ffoo}
          />
        ))}
        <CTA
          disabled={
            !selectedFilters?.ffoo ||
            (selectedFilters?.search_text &&
              selectedFilters?.search_text?.length < 3)
          }
          btnText="Cerca"
          onClick={() => handleGetTutorList()}
          fullsize={mediaIsPhone}
        />
      </FiltersWrapper>
      <SortingWrapper>
        {selectedFilters?.regions ? (
          <Inline columnGap="16px">
            <Text type="b3">
              {tutors_by_region ?? 0}
              <span style={{ fontSize: '14px' }}>/{totalTutors ?? 0}</span>
              &nbsp;&nbsp;utenti
            </Text>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1"
              height="15"
              viewBox="0 0 1 15"
              fill="none"
            >
              <path d="M0.5 0.5V14.5" stroke="black" />
            </svg>
            <Text type="b3" color={theme().colors.primaryDarkGray700}>
              {toPercentage(tutors_by_region, totalTutors)}
            </Text>
            <CustomTooltip
              type="primary"
              title="Percentuale tutor"
              tooltipKey="tutor_percentage"
              mt={-4}
            />
          </Inline>
        ) : (
          <Text type="b3">{totalTutors ?? 0} utenti</Text>
        )}
        <SortBy
          options={getSortingOptions([
            'last_access_asc',
            'last_access_desc',
            'alphabetical_asc',
            'alphabetical_desc',
          ])}
          onChange={(v) => {
            setSelectedFilters({ ...selectedFilters, sort_by: v?.value });
          }}
        />
      </SortingWrapper>
      <Legend>
        <Text type="statistics-heading">Nome e cognome</Text>
        <Text type="statistics-heading">Matricola</Text>
        <Text type="statistics-heading">Forza dell'ordine</Text>
        <Text type="statistics-heading">Ruolo</Text>
        <Text type="statistics-heading">Regione</Text>
        <Text type="statistics-heading">Provincia</Text>
        <Text type="statistics-heading">N. percorsi gestiti</Text>
        <Text type="statistics-heading">Ultimo accesso</Text>
      </Legend>
      <ScrollableArea ref={scrollableAreaRef} preserveShadows>
        {list?.length > 0 ? (
          (list || []).map((tutor, i) => (
            <TutorCard key={`tutor-${i}`}>
              <Text
                type="h3"
                className="ellipsis"
                onClick={() => {
                  navigate(`${routes.tutorStatistics.path}/${tutor?.uid}`);
                  modalClose();
                }}
              >
                {tutor?.name} {tutor?.surname}
              </Text>
              <Text type="b4">{tutor?.matricola}</Text>
              <Text type="b4">{tutor?.ffoo}</Text>
              <Text type="b4">{tutor?.work_role_value}</Text>
              <Text type="b4">{tutor?.region}</Text>
              <Text type="b4">{tutor?.province}</Text>
              <Text type="b4">{tutor?.visible_courses}</Text>
              <Text type="b4">
                {timestampToDate(tutor?.last_access, 'DD/MM/YYYY - HH:mm')}
              </Text>
            </TutorCard>
          ))
        ) : (
          <NoResult />
        )}
      </ScrollableArea>
      <Footer pt={40} pb={48}>
        <Pagination
          pb={0}
          pager={pager}
          callBack={loadMore}
          setItemsPerPage={setItemsPerPage}
        />
      </Footer>
    </Modal>
  );
};

ModalSupervisorTutors.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  total_tutor: PropTypes.number,
  tutors_by_region: PropTypes.number,
  list: PropTypes.array,
  filters: PropTypes.object,
  pager: PropTypes.object,
  // dispatch
  getTutorList: PropTypes.func.isRequired,
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { total_tutor, tutors_by_region, list, filters, pager } =
        state.supervisorStats.lists.tutors;
      return { total_tutor, tutors_by_region, list, filters, pager };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getTutorList: (filters) =>
        dispatch({ type: TUTOR_LIST_GET._REQUEST, filters }),
    })
  ),
  withMediaQueries
)(ModalSupervisorTutors);
